import React from "react";
import { SkeletonBlock, SkeletonCircle } from "../ui/Skeleton/Skeleton";

const WorkoutPostCardSkeleton = () => (
  <div className="wpc" aria-hidden="true">
    <header className="wpc-header">
      <SkeletonCircle size={42} />
      <div className="wpc-header-info" style={{ flex: 1 }}>
        <SkeletonBlock width="40%" height={12} />
        <SkeletonBlock width="25%" height={10} style={{ marginTop: 6 }} />
      </div>
    </header>
    <SkeletonBlock width="55%" height={18} style={{ margin: "14px 0" }} />
    <SkeletonBlock height={140} radius={16} />
    <SkeletonBlock height={54} radius={12} style={{ marginTop: 14 }} />
  </div>
);

export default WorkoutPostCardSkeleton;
